import React, { forwardRef, useMemo } from "react";
import { Box } from "@mui/material";
import FastEntryInvoice from "./FastEntryInvoice";
import NewFastEntryInvoice from "./NewFastEntryInvoice";
import useInvoiceManagement from "./hooks/useInvoiceManagement";

// Memoize the FastEntryInvoice component
const MemoizedFastEntryInvoice = React.memo(FastEntryInvoice);

const FastEntryInvoiceContainer = forwardRef((props, ref) => {
  // Destructure height and minHeight from props, defaulting to the original values
  const { height = { xs: "auto", lg: "calc(100vh - 240px)" }, minHeight = { xs: "200px", lg: "400px" } } = props;
  // Use our custom hook for invoice management
  const {
    invoices,
    handleAddNewInvoice,
    handleDeleteInvoice,
    handleUpdateInvoice,
    handleToggleInvoiceSelected
  } = useInvoiceManagement({ ref });

  // Memoize the invoice list to prevent unnecessary re-renders
  const invoiceList = useMemo(() => {
    return invoices.map((invoice) => (
      <MemoizedFastEntryInvoice 
        key={invoice.id} 
        invoice={invoice} 
        onDelete={handleDeleteInvoice}
        onUpdate={handleUpdateInvoice}
        selected={invoice.selected}
        onToggleSelected={handleToggleInvoiceSelected}
      />
    ));
  }, [invoices, handleDeleteInvoice, handleUpdateInvoice, handleToggleInvoiceSelected]);

  return (
    <Box 
      sx={{ 
        flexGrow: 1,
        height,
        minHeight,
        overflow: "auto",
        "& > div:not(:last-child)": {
          marginBottom: "1rem"
        }
      }}
    >
      {invoiceList}
      <NewFastEntryInvoice onAdd={handleAddNewInvoice} />
    </Box>
  );
});

export default FastEntryInvoiceContainer;